import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureFirstTouch } from "@/lib/analytics/attribution";
import { captureInternalFromUrl } from "@/lib/analytics/visitor";
import { startConsentLoader, stopTrackingForAppNavigation } from "@/lib/consent/loader";
import { installDomResilience } from "@/lib/domResilience";
import { initializeAppContext, isAppContext } from "@/lib/appContext";
// Dev/test only: attaches window.__fsExperiments for Playwright. The side-effect
// at the bottom of the module is guarded by !import.meta.env.PROD, so nothing is
// attached in production.
import "@/lib/experiments/useExperiment";

// Capture first-touch attribution + internal-traffic flag before anything
// renders, so every event carries them. (Attribution capture is a no-op for
// unconsented visitors; the consent loader re-runs it on grant.)
initializeAppContext(stopTrackingForAppNavigation);
if (!isAppContext()) {
  const vimeoPreconnect = document.createElement("link");
  vimeoPreconnect.rel = "preconnect";
  vimeoPreconnect.href = "https://player.vimeo.com";
  vimeoPreconnect.crossOrigin = "anonymous";
  document.head.appendChild(vimeoPreconnect);
}
captureFirstTouch();
captureInternalFromUrl();

// FIV-657 safety net: in-browser page translators move the text nodes React
// owns. Install before React touches the DOM, so a node it can no longer find
// degrades to an Error Tracking report instead of the router's error page.
// The fix proper is keeping volatile text in its own element (see the module).
installDomResilience();

// Render first. Trackers start after render via the consent loader below.
createRoot(document.getElementById("root")!).render(<App />);

// FIV-499: honor a stored consent choice (or wait for one). This is the only
// place trackers start; nothing loads for visitors who haven't chosen yet.
startConsentLoader();
